import { IntegrationConfiguration } from '@/models/product';
import { DateRange } from '@/models/general';

export enum BulkUpdateType {
    ACTIVE_STATUS,
    SET_DYNAMIC_PRICING,
    SET_REMOVE_CONDITION,
    SET_BOOKING_OPTIONS,
    SET_VALIDITY_OPTIONS,
    SET_START_DATE_VALIDITY_OPTIONS,
    SET_REMOVE_VALID_FROM_TO,
    SET_REMOVE_START_DATE_VALID_FROM_TO,
}

export type ConfigurationState = {
    activeStatus: boolean;
    setDynamicPricing: boolean;
    setRemoveConditions: boolean;
    setBookingOptions: boolean;
    setValidityOptions: boolean;
    setStartDateValidityOptions: boolean;
    setRemoveValidFromTo: boolean;
    setRemoveStartDateValidFromTo: boolean;
};

export const initialConfigurationState: ConfigurationState = {
    activeStatus: false,
    setDynamicPricing: false,
    setRemoveConditions: false,
    setBookingOptions: false,
    setValidityOptions: false,
    setStartDateValidityOptions: false,
    setRemoveValidFromTo: false,
    setRemoveStartDateValidFromTo: false,
};

export type SeTActiveStatusPayload = {
    type: BulkUpdateType.ACTIVE_STATUS;
    isActive: boolean;
};

export type SetDPPayload = {
    type: BulkUpdateType.SET_DYNAMIC_PRICING;
    conditionLinkIds: string[];
};

export type SetRemoveConditionPayload = {
    type: BulkUpdateType.SET_REMOVE_CONDITION;
    payload: boolean;
};

export type SetValidityOptionsPayload = {
    type: BulkUpdateType.SET_VALIDITY_OPTIONS;
    payload: DateRange;
};

export type SetStartDateValidityPayload = {
    type: BulkUpdateType.SET_START_DATE_VALIDITY_OPTIONS;
    payload: DateRange;
};

export type ConfigurationCollection = {
    integrationConfiguration: IntegrationConfiguration;
    portalConfiguration: IntegrationConfiguration;
    b2bConfiguration: IntegrationConfiguration;
    hospitalityConfiguration: IntegrationConfiguration;
};

export type SetBookingOptionsPayload = {
    type: BulkUpdateType.SET_BOOKING_OPTIONS;
    configurations: ConfigurationCollection;
};

export type SetRemoveValidFromToPayload = {
    type: BulkUpdateType.SET_REMOVE_VALID_FROM_TO;
    payload: boolean;
};

export type SetRemoveStartDateValidFromToPayload = {
    type: BulkUpdateType.SET_REMOVE_START_DATE_VALID_FROM_TO;
    payload: boolean;
};

export type BulkUpdateActionPayload =
    | SeTActiveStatusPayload
    | SetDPPayload
    | SetBookingOptionsPayload
    | SetRemoveConditionPayload
    | SetValidityOptionsPayload
    | SetStartDateValidityPayload
    | SetRemoveStartDateValidFromToPayload
    | SetRemoveValidFromToPayload;
